import { render, staticRenderFns } from "./ReworksToolbar.vue?vue&type=template&id=54839cde"
import script from "./ReworksToolbar.vue?vue&type=script&lang=js"
export * from "./ReworksToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports